<script setup>
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import logo1 from '../../assets/Deutsche_Bank-Logo.svg.png';
import logo2 from '../../assets/university_hospital_dusseldorf_Logo.svg.png';
import logo3 from '../../assets/logo-hamburgische-buergerschaft.png';
import logo4 from '../../assets/landespolizei-brandenburg.webp';
import logo0 from '../../assets/logo-cybersicherheitsrat.png';

const logos = [
  { src: logo0, alt: 'Cybersicherheistrat' },
  { src: logo1, alt: 'Deutsche Bank' },
  { src: logo2, alt: 'University Hospital Dusseldorf' },
  { src: logo3, alt: 'Hamburg Parliament' },
  { src: logo4, alt: 'Brandenburg Police' },
];

</script>

<template>
  <div class="bg-primary text-basecolor py-8 md:py-24 sm:px-2 lg:px-4 text-md">
    <div class="mx-auto max-w-7xl px-6">
      <div class="mx-auto max-w-2xl px-4 lg:max-w-none space-y-12">
        <h2 class="text-3xl font-bold tracking-tight">
          {{ $t('landingPage.aboutUsSection.title') }}
        </h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 items-start">
          <section>
            <h3 class="text-xl font-bold tracking-tight">
              {{ $t('landingPage.aboutUsSection.block1.title') }}
            </h3>
            <p class="mt-4">
              {{ $t('landingPage.aboutUsSection.block1.text') }}
            </p>
          </section>

          <section>
            <h3 class="text-xl font-bold tracking-tight">
              {{ $t('landingPage.aboutUsSection.block2.title') }}
            </h3>
            <p class="mt-4">
              {{ $t('landingPage.aboutUsSection.block2.text') }}
            </p>
          </section>

          <div class="flex justify-center self-center col-span-1 md:col-span-2 lg:col-span-1">
            <img
              src="../../assets/gamebook-services-logo-blue.png"
              alt="GameBook Services Logo Transparent"
              class="w-full max-w-[240px] lg:max-w-[240px] max-h-[240px] object-contain"
            >
          </div>
        </div>
        <section>
          <h3 class="text-xl font-bold tracking-tight">
            {{ $t('landingPage.aboutUsSection.block3.title') }}
          </h3>
          <p
            class="mt-4"
            v-html="$t('landingPage.aboutUsSection.block3.text')"
          />
        </section>

        <div class="block md:hidden">
          <Carousel
            :items-to-show="1"
            :wrap-around="true"
            :autoplay="2000"
            :transition="800"
            pause-autoplay-on-hover="true"
            class="w-full"
          >
            <Slide
              v-for="(logo, i) in logos"
              :key="i"
            >
              <div class="flex justify-center">
                <img
                  :src="logo.src"
                  :alt="logo.alt"
                  class="rounded-lg object-contain h-40"
                >
              </div>
            </Slide>
          </Carousel>
        </div>
        <div class="hidden md:grid grid-cols-2 lg:grid-cols-5 gap-6">
          <img
            v-for="(logo, i) in logos"
            :key="i"
            :src="logo.src"
            :alt="logo.alt"
            class="rounded-lg object-contain w-full h-36"
            :class="{ 'md:col-span-2 md:justify-self-center lg:col-span-1': i === logos.length - 1 }"
          >
        </div>
      </div>
    </div>
  </div>
</template>
